import type { CSSProperties } from "react";
import { normalizeLegacyStatus } from '@/shared/types';

export interface StaffColorPair {
  primaryColor: string;
  secondaryColor: string;
}

export const STAFF_COLOR_PAIRS: StaffColorPair[] = [
  { primaryColor: '#00AA55', secondaryColor: '#5AACCF' }, // Green & Aqua
  { primaryColor: '#009FD4', secondaryColor: '#E3BC00' }, // Blue & Yellow
  { primaryColor: '#B381B3', secondaryColor: '#FF8C42' }, // Purple & Orange
  { primaryColor: '#D47500', secondaryColor: '#00AA55' }, // Orange & Green
  { primaryColor: '#DC2A2A', secondaryColor: '#009FD4' }, // Red & Blue
  { primaryColor: '#5AACCF', secondaryColor: '#B381B3' }, // Aqua & Purple
  { primaryColor: '#E3BC00', secondaryColor: '#DC2A2A' }, // Yellow & Red
  { primaryColor: '#939393', secondaryColor: '#8B7355' }, // Grey & Mocha
  { primaryColor: '#8B7355', secondaryColor: '#00AA55' }, // Mocha & Green
  { primaryColor: '#FF8C42', secondaryColor: '#5AACCF' }, // Clementine & Aqua
  { primaryColor: '#00C853', secondaryColor: '#FF4081' }, // Frog Green & Hot Pink
  { primaryColor: '#2E67A0', secondaryColor: '#EFFC93' }, // Lapis & Key Lime
];

export function getColorPairForIndex(index: number): StaffColorPair {
  return STAFF_COLOR_PAIRS[index % STAFF_COLOR_PAIRS.length];
}

export function buildDiagonalStripeGradient(
  primaryColor: string,
  secondaryColor: string
): string {
  return `linear-gradient(45deg, ${primaryColor} 50%, ${secondaryColor} 50%)`;
}

export function buildStaffIndicatorStyle(
  primaryColor: string | null | undefined,
  secondaryColor: string | null | undefined
): CSSProperties {
  const primary = primaryColor || '#8B7355';
  const secondary = secondaryColor || '#F5E6D3';
  
  return {
    background: buildDiagonalStripeGradient(primary, secondary),
  };
}

// New 4-status system colors (unscheduled → scheduled → in-progress → completed)
export const STATUS_COLORS: Record<string, string> = {
  'unscheduled': '#9CA3AF',       // Grey - Unscheduled (matches bg-gray-400)
  'scheduled': '#3B82F6',         // Blue - Scheduled (matches bg-blue-500)
  'in-progress': '#F97316',       // Orange - In Progress (matches bg-orange-500)
  'completed': '#22C55E',         // Green - Completed (matches bg-green-500)
};

export function getJobStatusColor(status: string | null | undefined): string {
  if (!status) return '#939393'; // Default grey
  
  // Normalize legacy statuses using shared helper
  const normalized = normalizeLegacyStatus(status);
  
  // Return color for normalized status
  return STATUS_COLORS[normalized] || '#939393';
}
